module.exports = __webpack_public_path__ + "media/images/city/079-dome-of-the-rock-b13cbd191116d6c9e19023ffa1db5dd8.svg";